import type { CartProduct } from '@/context/CartContext';

interface ProductCardProps {
  product: CartProduct;
  onAdd: (product: CartProduct) => void;
}

export default function ProductCard({ product, onAdd }: ProductCardProps) {
  const outOfStock = product.stock <= 0;
  const lowStock = product.stock > 0 && product.stock <= 5;

  return (
    <div
      className={`bg-white rounded-md border overflow-hidden transition-all duration-200 hover:border-primary-300 group ${
        outOfStock ? 'border-background-200 opacity-75' : 'border-background-200'
      }`}
      data-product-shop
    >
      <div className="relative aspect-[4/3] bg-background-50 overflow-hidden">
        <img
          src={product.imagen}
          alt={product.nombre}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
        />
        {outOfStock && (
          <div className="absolute inset-0 bg-foreground-800/50 flex items-center justify-center">
            <span className="bg-white/90 text-foreground-800 text-[10px] font-semibold px-2 py-1 rounded-full">
              Sin Stock
            </span>
          </div>
        )}
        {lowStock && (
          <span className="absolute top-2 right-2 bg-accent-500 text-white text-[8px] font-semibold px-1.5 py-0.5 rounded-full leading-none">
            {product.stock}
          </span>
        )}
      </div>

      <div className="p-2">
        <h3 className="text-xs font-medium text-foreground-800 leading-tight line-clamp-2 mb-1">
          {product.nombre}
        </h3>
        <p className="text-sm font-bold text-primary-600 mb-1">
          Bs. {product.precio.toFixed(2)}
        </p>
        <p className="text-[10px] text-foreground-400 mb-2">
          Stock: {product.stock}
        </p>
        <button
          onClick={() => onAdd(product)}
          disabled={outOfStock}
          className={`w-full py-1.5 rounded text-xs font-medium transition-all duration-200 flex items-center justify-center gap-1.5 cursor-pointer whitespace-nowrap ${
            outOfStock
              ? 'bg-background-200 text-foreground-400 cursor-not-allowed'
              : 'bg-primary-500 hover:bg-primary-600 text-white'
          }`}
        >
          <i className="ri-shopping-cart-line text-xs"></i>
          <span>{outOfStock ? 'Sin Stock' : 'Agregar'}</span>
        </button>
      </div>
    </div>
  );
}